import { Component, OnInit } from "@angular/core";
import { FormControl, Validators, FormGroup, FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import { CompanyService } from "src/app/ui/services/pbm/company.service";
import { Company } from "src/app/ui/models/domains/pbm/companies/company";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { LoadingService } from "src/app/ui/services/loading.service";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { Toast } from "../../../toast/toast";
import { CompanyValidator } from "../validators/company-validator";
import { CompanyHandler } from "src/app/ui/models/domains/pbm/companies/company-handler";
import { UserPermissions } from "./../../../../models/domains/pbm/user/user-permissions";
import { UserService } from "src/app/ui/services/user.service";
import { RoutePath } from "src/app/ui/models/domains/route-paths.model";

@Component({
  selector: "create-company",
  templateUrl: "./create-company.component.html",
  styleUrls: ["./create-company.component.scss"],
})
export class CreateCompanyComponent implements OnInit {
  telephoneMask = MaskInput.getTelephoneMask();
  mobileMask = MaskInput.getMobileMask();
  fiscalNumberMask = MaskInput.getFicalNumberMask();
  zipCodeMask = MaskInput.getZipCodeMask();
  federalRegistrationMask = MaskInput.getFederalRegistrationMask();
  socialNumberMask = MaskInput.getSocialNumberMask();

  company: Company = new Company();

  formCompanyRegistration: FormGroup;

  constructor(
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder,
    private loadingService: LoadingService,
    private featureViewService: FeatureViewService,
    private companyService: CompanyService,
    private toast: Toast,
    private userService: UserService,
    private router: Router,
  ) { }

  ngOnInit() {
    const fiscalNumber = this.activatedRoute.snapshot.queryParams.f;
    this.featureViewService.activeFeatureView(FeatureViews.CompanyRegistrationFeatureView, PageViews.CompanyPageView);
    this.formCompanyRegistration = this.formBuilder.group({
      companyKey: new FormControl(""),
      unit: new FormControl("", Validators.required),
      companyType: new FormControl(""),
      headOfficeFiscalNumber: new FormControl("", Validators.required),
      fiscalNumber: new FormControl(fiscalNumber, Validators.required),
      stateRegistration: new FormControl(""),
      municipalRegistration: new FormControl(""),
      corporateName: new FormControl("", Validators.required),
      tradingName: new FormControl(""),
      street: new FormControl("", Validators.required),
      number: new FormControl("", Validators.required),
      complement: new FormControl(""),
      district: new FormControl("", Validators.required),
      city: new FormControl("", Validators.required),
      region: new FormControl("", Validators.required),
      zipCode: new FormControl("", Validators.required),
      employeeCount: new FormControl(0, [Validators.required]),
    });
  }

  async submitCompanyData() {
    const ref = this.loadingService.beginLoading();
    const companyValidator = new CompanyValidator();
    if (companyValidator.validate(this.formCompanyRegistration).hasErrorMessages()) {
      this.toast.showWarningToast(companyValidator.getValidationResult().getErrorMessage());
      this.loadingService.finishLoading(ref);
    } else {
      const companyHandler = new CompanyHandler(this.formCompanyRegistration);
      const company = companyHandler.handleFormToCompany();
      try {
        const companyKey = await this.companyService.addCompany(company);
        this.formCompanyRegistration.patchValue({ companyKey });
        this.toast.showSuccessToast("Empresa salva com sucesso");
        this.router.navigate([RoutePath.EditCompany, company.getFiscalNumber()]);
      } catch (error) {
        this.toast.showWarningToast(error);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    }
  }

  hasAccessToCreateCompany(): boolean {
    return this.userService.getLoggedUser().hasPermission(UserPermissions.RegisterCompany);
  }

  public backToSearchCompanies(): void {
    this.router.navigate([RoutePath.SearchCompany]);
  }
}
